export default __webpack_public_path__ + "static/media/i01.92dd0daf.png";